import { useCallback, useEffect, useRef, useState } from "react";
import { secrets, useNotepadStore } from "../store/notepad";

export default function Notepad({ style = {} }) {
  const detailsEl = useRef();
  const [open, setOpen] = useState(false);
  const store = useNotepadStore((state) => state.secrets);

  // Listen for clicks outside of the notepad and then close it
  const closeDetails = useCallback((e) => {
    if (open && !detailsEl.current.contains(e.target)) setOpen(false);
  });

  function HiddenSecret({ hiddenValue }) {
    return typeof hiddenValue === "object" ? (
      <>
        {" "}
        {hiddenValue.hiddenDate}/
        <span className="notepad__secret--discovered">
          {hiddenValue.visibleYear}
        </span>
      </>
    ) : (
      <> {hiddenValue} </>
    );
  }

  useEffect(() => {
    window.addEventListener("click", closeDetails);
    return () => window.removeEventListener("click", closeDetails);
  }, [closeDetails]);

  return (
    <div className="notepad" ref={detailsEl} style={style}>
      <button className="notepad__trigger" onClick={() => setOpen((o) => !o)}>
        <svg
          className="notepad__trigger-icon"
          fill="currentColor"
          viewBox="0 0 46 46"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M16.6003 17.0635C16.6003 16.5172 17.0553 16.0743 17.6166 16.0743H27.7805C28.3417 16.0743 28.7969 16.5172 28.7969 17.0635C28.7969 17.6097 28.3417 18.0526 27.7805 18.0526H17.6166C17.0553 18.0526 16.6003 17.6097 16.6003 17.0635ZM17.6166 22.0091C17.0553 22.0091 16.6003 22.452 16.6003 22.9982C16.6003 23.5444 17.0553 23.9873 17.6166 23.9873H27.7805C28.3417 23.9873 28.7969 23.5444 28.7969 22.9982C28.7969 22.452 28.3417 22.0091 27.7805 22.0091H17.6166ZM16.6003 28.9329C16.6003 28.3868 17.0553 27.9438 17.6166 27.9438H21.6822C22.2435 27.9438 22.6986 28.3868 22.6986 28.9329C22.6986 29.4791 22.2435 29.9221 21.6822 29.9221H17.6166C17.0553 29.9221 16.6003 29.4791 16.6003 28.9329ZM14.5675 7.17223C14.5675 6.62596 15.0225 6.18311 15.5839 6.18311C16.1452 6.18311 16.6003 6.62596 16.6003 7.17223V8.16135H21.6822V7.17223C21.6822 6.62596 22.1372 6.18311 22.6986 6.18311C23.2598 6.18311 23.715 6.62596 23.715 7.17223V8.16135H28.7969V7.17223C28.7969 6.62596 29.252 6.18311 29.8133 6.18311C30.3745 6.18311 30.8296 6.62596 30.8296 7.17223V8.16135H31.846C33.53 8.16135 34.8952 9.48988 34.8952 11.1287V20.4891C34.2321 20.7655 33.6111 21.1671 33.0698 21.6938L32.8624 21.8956V11.1287C32.8624 10.5824 32.4073 10.1396 31.846 10.1396H13.5511C12.9898 10.1396 12.5347 10.5824 12.5347 11.1287V34.8677C12.5347 35.4139 12.9898 35.8568 13.5511 35.8568H21.114L20.782 37.149C20.7226 37.3803 20.6864 37.6093 20.6716 37.8351H13.5511C11.8671 37.8351 10.502 36.5065 10.502 34.8677V11.1287C10.502 9.48988 11.8671 8.16135 13.5511 8.16135H14.5675V7.17223ZM34.5073 23.0928L24.6903 32.6465C24.1178 33.2036 23.7117 33.9015 23.5153 34.6657L22.7543 37.6289C22.4231 38.9176 23.6227 40.0847 24.9468 39.7627L27.9917 39.0218C28.777 38.8307 29.4941 38.4357 30.0665 37.8786L39.8836 28.3248C41.3681 26.8799 41.3681 24.5375 39.8836 23.0928C38.3991 21.6479 35.9919 21.6479 34.5073 23.0928Z" />
        </svg>
      </button>
      <div className="notepad__content" data-open={open}>
        <div className="notepad__inner-content">
          {Object.entries(secrets).map(([key, value]) => (
            <span className="notepad__secret" key={key}>
              {value.label}:
              {store[key] ? (
                <span className="notepad__secret--discovered">
                  {value.value}
                </span>
              ) : (
                <HiddenSecret hiddenValue={value.hidden} />
              )}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
